//@flow
import * as React from 'react'
import { BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import DocLandingContainer from './DocLandingContainer';
import SubmittedForm from './SubmittedForm';

const FormView = (props:any) => {
    const { match,location } = props;
    
    switch (match.params.name){
        case "docLandingContainer":
            return <DocLandingContainer location={location} />;
        case "submittedForm":
            return <SubmittedForm />
        default:
            return null;        
    }
}

const ProjectKratosEC = (props:any) => {
    const { match } = props;
    return (
        <Router>
          <div>
             <Switch>
               <Route path={`${match.path}/:name`} component={FormView} />
               <Route path={`${match.path}/:name?jwt=:jwt&pdfUrl=:pdfUrl&taskAcceptedInfoId=:taskAcceptedInfoId`} component={FormView} />
               <Route render={()=>(
                   <h3>Project Kratos EC</h3>
               )}/>
             </Switch> 
          </div>  
        </Router>
    )
}

export default ProjectKratosEC;


// WEBPACK FOOTER //
// ./src/views/ProjectKratosEC/ProjectKratosEC.js